import styles from "./AnalyticsSegmentedBar.module.scss";

const SEGMENT_COUNT = 10;

type Props = {
	/** 0–100. Rounded to the nearest whole segment, so the bar moves in 10% steps. */
	percent: number;
};

/** Ten-segment completion bar under a metric. */
const AnalyticsSegmentedBar = ({ percent }: Readonly<Props>) => {
	const clamped = Math.min(Math.max(percent, 0), 100);
	const filled = Math.round((clamped / 100) * SEGMENT_COUNT);

	return (
		<div
			className={styles.bar}
			role="progressbar"
			aria-valuenow={clamped}
			aria-valuemin={0}
			aria-valuemax={100}
		>
			{Array.from({ length: SEGMENT_COUNT }, (_, index) => (
				<span key={index} className={`${styles.segment} ${index < filled ? styles.filled : ""}`} />
			))}
		</div>
	);
};

export default AnalyticsSegmentedBar;
